import { render, staticRenderFns } from "./index.vue?vue&type=template&id=323ab401&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('323ab401')) {
      api.createRecord('323ab401', component.options)
    } else {
      api.reload('323ab401', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=323ab401&", function () {
      api.rerender('323ab401', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/WangEditer/index.vue"
export default component.exports